import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withSizes from 'react-sizes';
import { openModal } from '../../redux/actions';
import UserNavigation from '../UserNavigation';
import MockUser from '../../assets/img/avatar.jpg';
import MockUserInner from '../../assets/img/avatar_inner.jpg';
import {
  UserContainer,
  UserDropdown,
  UserName,
  Avatar,
  ButtonContainer,
  LoginButton,
  SignUpButton,
} from './styles';

const User = ({ user, handleModalOpenClick, isInnerPage, isOpen, isDesktop }) => {
  let content;

  const renderUserAvatar = () => {
    let userImage;

    if (user.avatar) {
      userImage = user.avatar.includes('http') ? user.avatar : `${process.env.AVATAR_URL}${user.avatar}`;
    }

    if (!user.avatar && !isInnerPage) {
      userImage = MockUser;
    }

    if (!user.avatar && isInnerPage) {
      userImage = MockUserInner;
    }

    return userImage;
  };

  if (user) {
    content = (
      <UserContainer>
        <Link href="/my-account">
          <a>
            <Avatar isInnerPage={isInnerPage}>
              <img src={renderUserAvatar()} alt={user.firstName || user.lastName ? `${user.firstName} ${user.lastName || 'Unknown'}` : 'Unknown Guest'} />
            </Avatar>
            <UserName>{user.firstName || user.lastName ? `${user.firstName} ${user.lastName || 'Unknown'}` : 'Unknown Guest'}</UserName>
          </a>
        </Link>
        {isDesktop && (
          <UserDropdown data-dropdown>
            <UserNavigation />
          </UserDropdown>
        )}
      </UserContainer>
    );
  } else {
    content = (
      <ButtonContainer isOpen={isOpen}>
        <LoginButton
          type="button"
          btnType="primary"
          onClick={() => handleModalOpenClick('login')}
          isInnerPage={isInnerPage}
          isOpen={isOpen}
        >
          Login
        </LoginButton>
        <SignUpButton
          type="button"
          onClick={() => handleModalOpenClick('registration')}
          isInnerPage={isInnerPage}
          isOpen={isOpen}
        >
          Sign Up
        </SignUpButton>
      </ButtonContainer>
    );
  }

  return content;
};

User.propTypes = {
  user: PropTypes.instanceOf(Object),
  handleModalOpenClick: PropTypes.func,
  handleLogoutClick: PropTypes.func,
  openedModal: PropTypes.string,
  isInnerPage: PropTypes.bool,
  isDesktop: PropTypes.bool,
};

const mapStateToProps = state => ({
  user: state.user.userData,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleModalOpenClick: openModal,
}, dispatch);

const mapSizesToProps = ({ width }) => ({
  isDesktop: width > 1024,
});

export default connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(User));
